module.exports = __webpack_public_path__ + "static/media/pw.ed066a4f.svg";